import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RadioGroup } from 'react-radio-group'

import PropTypes from 'prop-types'
import { Radio } from '../../components'
import { useRadioButton } from '../../utils/useForm'
import { fieldUpdateSettingsAction } from '../utils/slices'
import FormGroup from '../components/FormGroup'

const propTypes = {
  /**
   * Decide whether the Font Size `FormGroup` is included in the Settings
   */
  containFontSize: PropTypes.bool,
  /**
   * Decide whether the Orientation `FormGroup` is included in the Settings
   */
  containOrientation: PropTypes.bool,
  /**
   * Decide whether the Theme `FormGroup` is included in the Settings
   */
  containTheme: PropTypes.bool
}

const defaultProps = {
  containTheme: true,
  containFontSize: true,
  containOrientation: true
}

const Settings = (props) => {
  const dispatch = useDispatch()
  const { orientation, fontSize, theme } = useSelector((state) => state.settings)

  const {appCode, containTheme, containFontSize, containOrientation} = Object.assign({}, defaultProps, props)

  const onChangeCB = (name, value) => {
    console.log(name, value)

    const itemName = 'sst_bp_' + props.appCode + '_settings'
    const settings = JSON.parse(localStorage.getItem(itemName))
    const newSettings = Object.assign({}, settings, {[name]: value})
    localStorage.setItem(itemName, JSON.stringify(newSettings))

    if (name === 'fontSize') {
      document.documentElement.classList.remove('-densityCompact', '-densityDefault')
      document.documentElement.classList.add(value)
    } else if (name === 'theme') {
      document.documentElement.classList.remove('-themeLight', '-themeDark')
      document.documentElement.classList.add(value)
    }
    dispatch(
      fieldUpdateSettingsAction({
        [name]: value
      }),
    )
  }
  const orientationObj = useRadioButton('orientation', orientation, onChangeCB)
  const fontSizeObj = useRadioButton('fontSize', fontSize, onChangeCB)
  const themeObj = useRadioButton('theme', theme, onChangeCB)

  return (
    <>
      {/* {getTheme(containTheme, themeObj)} */}
      {getFontSize(containFontSize, fontSizeObj)}
      {getOrientation(appCode, containOrientation, orientationObj)}
      {/* { appCode !== 'PBS' ?
        getOrientation(appCode, containOrientation, orientationObj)
        : null
      } */}
    </>
  )
}

const getTheme = (containTheme, themeObj) => {
  if (containTheme) return (
    <FormGroup label='Background Theme'>
      <RadioGroup className="radioGroup" {...themeObj}>
        <label className="inputLabel">
          <Radio value='-themeLight' />
          <span>Light Theme</span>
        </label>
        <label className="inputLabel">
          <Radio value='-themeDark'/>
          <span>Dark Theme</span>
        </label>
      </RadioGroup>
    </FormGroup>
  )
}

const getFontSize = (containFontSize, fontSizeObj) => {
  if (containFontSize) return (
    <FormGroup label='Display Density'>
      <RadioGroup className="radioGroup" {...fontSizeObj}>
        <label className="inputLabel">
          <Radio value='-densityCompact' />
          <span>Compact</span>
        </label>
        <label className="inputLabel">
          <Radio value='-densityDefault' />
          <span>Default</span>
        </label>
      </RadioGroup>
    </FormGroup>
  )
}

const getOrientation = (appCode, containOrientation, orientationObj) => {
  if (containOrientation) return (
    <FormGroup label='Pane Orientation'>
      <RadioGroup className="radioGroup" {...orientationObj}>

        <label className="inputLabel">
          <Radio value='vertical'/>
          <span>Vertical</span>
        </label>

        <label className="inputLabel">
          <Radio value='horizontal' />
          <span>Horizontal</span>
        </label>

      </RadioGroup>
    </FormGroup>
  )
}

Settings.propTypes = propTypes
Settings.defaultProps = defaultProps

export default Settings
